import React, { useCallback } from 'react';
import { prop } from 'ramda';
import { requestVerificationUrl } from './helpers';
import { usePortletConfig } from '@core/js/components/system/Portlet';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';
import { useTranslations } from '@core/js/hooks/i18n';
import { ButtonSettings, ShuftiConfig } from './types';

import style from './index.scss';
import { clsx } from '@core/js/utils/classNames.util';
import { SHUFTI_VARIANTS } from './enums';

type ShuftiVerificationButtonProps = {
    variant: SHUFTI_VARIANTS,
    setVerificationUrl?: (url: string) => void,
    settings?: ButtonSettings | null
    config?: ShuftiConfig
}

const ShuftiVerificationButton: React.FC<ShuftiVerificationButtonProps> = ({
    variant = SHUFTI_VARIANTS.DEFAULT,
    settings = {},
    config,
    setVerificationUrl
}) => {
    const portletConfig = usePortletConfig() as ShuftiConfig;
    const casinoName = useAppSelector(prop('casinoName'));
    const userName = useUserSelector(prop('userName')) as string;

    const t = useTranslations('playtech.mobile.system.shufti.verificationButton.');

    const { authorization, url } = { ...config, ...portletConfig };

    const handleVerificationClick = useCallback(async () => {
        const verificationUrl = await requestVerificationUrl(userName, url, authorization, casinoName);
        setVerificationUrl?.(verificationUrl);
    }, [authorization, url, casinoName, userName, setVerificationUrl]);

    const isDefaultButton = variant === SHUFTI_VARIANTS.DEFAULT;
    const isLinkButton = variant === SHUFTI_VARIANTS.LINK;
    const isEmailButton = variant === SHUFTI_VARIANTS.EMAIL;

    return settings ? (
        <a
            className={clsx([style.verificationButton, isLinkButton && style.link])}
            {...((settings as ButtonSettings)?.disabled && { 'aira-disabled': 'true' })}
            {...(isDefaultButton ? { onClick: handleVerificationClick } : { href: 'mailto:verificacion@codere.mx' })}>
            {isEmailButton && <span className={clsx([style.icon, style.email])}></span>}

            {t(variant)}
        </a>
    ) : null;
};

export default ShuftiVerificationButton;
